import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative py-4 px-6" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "flex items-center gap-3" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = { class: "relative hidden md:block" }
const _hoisted_9 = { class: "relative" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationsLists = _resolveComponent("NotificationsLists")!
  const _component_DarkSwtichBtn = _resolveComponent("DarkSwtichBtn")!
  const _component_LanguageMenu = _resolveComponent("LanguageMenu")!
  const _component_ToggleFullscreenBtn = _resolveComponent("ToggleFullscreenBtn")!
  const _component_AdminProfile = _resolveComponent("AdminProfile")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'header-area fixed top-0 z-[9999] transition-all duration-300 backdrop-blur-xl bg-white/95 dark:bg-[#0c1427]/95 border-b border-gray-200/50 dark:border-gray-700/50',
      { active: _ctx.stateStoreInstance?.open },
    ])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "menu-toggle-btn w-11 h-11 flex items-center justify-center rounded-xl text-gray-600 dark:text-white hover:text-gray-700 dark:hover:text-white transition-all duration-300 shadow-md hover:shadow-lg backdrop-blur-sm hover:scale-105",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance?.onChange && _ctx.stateStoreInstance?.onChange(...args)))
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "ri-menu-line text-xl" }, null, -1)
          ]))
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_NotificationsLists)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_DarkSwtichBtn)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_LanguageMenu)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_ToggleFullscreenBtn)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_AdminProfile)
          ])
        ])
      ])
    ])
  ], 2))
}